import { createWebSyncProvider } from "@hicya/sync/react/web";
import { useAuth } from "@hicya/auth-sdk/react";

import { SYNC_URL, tokenStorage } from "@/auth/config";
import { useDatabaseStatus } from "@/db/provider";

export const { SyncProvider, useSync } = createWebSyncProvider({
  syncUrl: SYNC_URL,
  useDatabaseApi: () => {
    const dbState = useDatabaseStatus();
    return dbState.status === "ready" ? dbState.api : null;
  },
  useAuth: () => {
    const { isAuthenticated } = useAuth();
    return {
      isAuthenticated,
      getAccessToken: () => tokenStorage.getTokens()?.accessToken ?? null,
    };
  },
});
